// removed by extract-text-webpack-plugin
module.exports = {"SignUpButtons":"SignUpButtons__SignUpButtons__1DuWc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Security/SignUpButtons/SignUpButtons.css
// module id = 151
// module chunks = 0